/**
 * Off-site destinations the public pages link to.
 *
 * The CLI documentation is its own site, and both the header and the landing
 * page hero point at it; keeping the URL here stops the two drifting apart.
 */
export const CLI_DOCS_URL = 'https://cli.debtdrone.net';

/**
 * The published support address, the same one the legal pages give.
 *
 * Enterprise enquiries go here rather than to a `/contact` route: there is no
 * such page, and linking to one that does not exist sends visitors — and
 * crawlers — to a 404.
 */
export const SUPPORT_EMAIL = 'support@debtdrone.net';

export const SALES_CONTACT_HREF = `mailto:${SUPPORT_EMAIL}`;
